module.exports = __webpack_public_path__ + "static/media/SimplonNorm-Bold.ac4d6dac.woff";